import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { getOrganizationGradesQuery } from "MyCalendar/components/EventModalV2/modules/EventModalV2Query";
import _ from "lodash";

const useServerFilteredGrades = ({ organizationId, searchText }) => {
  const { data, loading, error } = useQuery(getOrganizationGradesQuery, {
    variables: {
      organizationId,
      gradeFilters: { searchText },
      getCurriculumProgram: true,
    },
    fetchPolicy: "cache-and-network",
    skip: !organizationId || !searchText,
    context: {
      useHttpLink: true,
    },
  });

  const grades = useMemo(() => _.get(data, "node.grades", []), [data]);

  return { grades, loading, error };
};

export default useServerFilteredGrades;
